<template>
  <textarea ref="codeEditor"></textarea>
</template>

<script>
/* eslint-disable */
import CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import '@/utils/minEmmet'
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/mode/clike/clike'
import 'codemirror/mode/python/python'
import { getMode } from '@/common/js/utils'
export default{
  components: {
  },
  props: {
    isLive: {
    },
    codeCinfig: {
    },
    options: {
    }
  },
  data() {
    return {
      config: {
        lineNumbers: true,
        matchBrackets: true,
        autoCloseBrackets: true,
        tabSize: 4,
        lineWrapping: true,   // 代码折叠
        // mode: 'text/html',
        mode: '',
        line: true
        // readOnly: true
      },
      codeContent: ''
    }
  },
  created() {
    // this.config.mode = getMode(this.languageId)
    // console.log('mode-----', this.config.mode)
  },
  mounted() {
    this.initEditor()
  },
  methods: {
    initEditor () {
      let _this = this
      this.editor = CodeMirror.fromTextArea(this.$refs.codeEditor, this.config)
    },
    clearContent: function() {
    }
  },
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?ba2a2eb0